import React from 'react';
import { Select, Spin } from 'antd';
import { useJobTitlesData } from '../hooks/useJobTitleData';
import { jobTitleSelectFilter } from '../filter/jobTitleSelect.filter';

export const JobTitlesSelect = React.forwardRef(({
  value, onChange,
}, ref) => {
  const { data, loading, error } = useJobTitlesData();

  if (loading) {
    return <Spin size="small" />;
  }

  if (error) {
    return <span>Erro ao carregar opções.</span>;
  }

  return (
    <Select
      showSearch
      value={value}
      onChange={onChange}
      ref={ref}
      filterOption={jobTitleSelectFilter}
    >
      <Select.Option value="" groupname="">Selecione uma opção</Select.Option>

      {data.map((fieldOfWork) => (
        <Select.OptGroup key={fieldOfWork.fieldOfWorkId} label={fieldOfWork.fieldOfWorkName}>
          {fieldOfWork.jobTitles.map((jobTitle) => (
            <Select.Option
              key={jobTitle.jobTitleId}
              value={jobTitle.jobTitleId}
              groupname={fieldOfWork.fieldOfWorkName}
            >
              {jobTitle.jobTitleName}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  );
});
